import React from 'react'
import {useDispatch} from 'react-redux'
import {useIsFeatureToggledChatEnabled} from 'hooks/useIsFeatureToggledChatEnabled'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'

import {openChat} from '../../modules/vioMcpChat/modules/slice'

export const HeaderChatButton = () => {
  const dispatch = useDispatch()
  const isFeatureToggledChatEnabled = useIsFeatureToggledChatEnabled()

  return isFeatureToggledChatEnabled ? (
    <Button
      variant="primary"
      size="md"
      onClick={() => dispatch(openChat())}
      ariaLabel="Open chat"
      dataId="HeaderChatButton"
      iconStart={
        <Icon name="DoubleChatBubble" colorPath="content.neutral.inverse" />
      }
    />
  ) : null
}
